<template>
  <div class="MyAccountMenu_Nav-mobile">
    <h3 class="title">{{ $t('myaccount.nav.title', 'My subscriptions') }}</h3>
    <app-select
      v-model="currentNavigation"
      :options="menuOptions || []"
      :allow-empty="false"
      :show-labels="false"
      :searchable="false"
      open-direction="bottom"
      label="name"
      class="mobilefontcolor"
      track-by="name"
      data-name="myAccountNav-selectItem"
    >
      <template slot="option" slot-scope="props">
        <router-link
          class="multiselect__option"
          :to="{path: props.option.route.path, query: { language:  props.option.route.query.language }  }"
          :key="props.option.code"
          @click.native="trackConversion({ name: 'interaction', description: `${props.option.analyticsCode}` })"
        >
          {{ props.option.name }}
          <span
            v-if="props.option.code === 'Billing' && hasOpenBalance"
            class="bubble-notification"
          >
            !
          </span>
        </router-link>
      </template>
    </app-select>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'my-account-nav-mobile',

    props: {
      menuOptions: {
        type: Array,
        required: true
      }
    },

    computed: {
      currentNavigation: {
        get () {
          let routerName = this.$route.name
          let currentNavigation = {}
          this.menuOptions.forEach(function (item) {
            if (item.route.name === routerName) {
              currentNavigation = item
            }
          })
          return currentNavigation
        },

        set () {}
      },

      ...mapGetters('account', ['hasOpenBalance'])
    }
  }
</script>

<style lang="scss">
  .MyAccountMenu_Nav-mobile {
    .welcome {
      font-size: .24rem;
      font-weight: 300;
      margin-bottom: .05rem;
      color: #fff;
    }

    .title {
      font-size: .3rem;
      color: $white;
      margin-bottom: .14rem;
    }

    .multiselect {
      min-width: .5rem;
      color: #212121;

      &__option {
        color: #212121;
        line-height: .32rem;
        padding: .05rem;

        .router-link-active {
          color: #fff;
        }

        &--highlight {
          background: $white;
        }

        &--selected {
          background: #0066a1;
        }
      }

      &__element {
        > .multiselect__option {
          padding-top: .03rem;
          padding-bottom: .03rem;

          a {
            display: inline-flex;
            justify-content: space-between;
            width: 100%;
            align-content: space-between;
            align-items: center;
          }
        }
      }

      &__tags {
        padding-top: .13rem;
        padding-bottom: .13rem;
      }
    }

    .mobilefontcolor .multiselect__content-wrapper a {
      @include media(mobile) {
        color: #212121;
      }
    }
  }
</style>
